import Extension from "../base/extension";

import {onLCP, onINP, onCLS} from 'web-vitals/attribution';

/**
 * @see https://web.dev/articles/vitals-ga4
 * @see https://github.com/GoogleChrome/web-vitals#send-the-results-to-google-analytics
 * @see https://web.dev/articles/find-slow-interactions-in-the-field#collect_field_data_with_the_web-vitals_javascript_library 
 */
class WebVitals extends Extension {
  constructor(name) {
    super(name);
  }

  init() {  
    console.log(this.logPrefix, "Web Vitals extension initialized");

    onCLS(this.sendToGoogleAnalytics.bind(this));
    onINP(this.sendToGoogleAnalytics.bind(this));
    onLCP(this.sendToGoogleAnalytics.bind(this));
  }

  sendToGoogleAnalytics({name, delta, value, id, rating, attribution}) {
    const eventParams = {
      value: delta,
      metric_id: id,
      metric_value: value,
      metric_delta: delta,
    };

    switch (name) {
      case 'CLS':
        eventParams.debug_target = attribution.largestShiftTarget;
        break;
      case 'INP':
        eventParams.rating = rating;
        eventParams.debug_target = attribution.interactionTarget;
        eventParams.interaction_type = attribution.interactionType;
        eventParams.input_delay = attribution.inputDelay;
        eventParams.processing_duration = attribution.processingDuration;
        eventParams.presentation_delay = attribution.presentationDelay;
        break;
      case 'LCP':
        eventParams.debug_target = attribution.target;
        break;
    }

    // console.log(this.logPrefix, `Sending ${name} event to Google Analytics`, eventParams);
    // console.log(this.logPrefix, "Attribution", attribution);
    if(gtag){
      gtag('event', name, eventParams);
    }
  }
}

export default WebVitals;